<div [class.loader-hidden]="!show">
    <div class="loader-overlay">
        <div><p-progressSpinner></p-progressSpinner></div>
    </div>
  </div>
